<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('finance.expensesTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_expense: 'add_expense',
            receive_permission: 'mark_expense_received'
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addExpenseButton="true"
          :openAddExpenseModal="openAddExpenseModal"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          :showReceiveAll="true"
          :confirmReceiveAll="confirmReceiveAll"
          :showReceivedFilter="true"
          :receivedFilterChange="handleReceivedFilter"
          :receivedFilterItemsOverride="receivedFilterItems"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12 pt-0">
          <v-layout
            wrap
            style="margin: 0px"
          >
            <v-flex
              xs12
              sm8
              md5
            >
              <v-select
                style="width: 100%"
                autocomplete
                :items="suppliersList"
                v-model="tableData.supplier_id"
                :label="$t('columns.supplier')"
                single-line
                clearable
                @input="getResults()"
              />
            </v-flex>
          </v-layout>

          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.expense_id"
              >
                <td>
                  <input
                    type="checkbox"
                    :value="r.expense_id"
                    v-model="selectedIds"
                  />
                </td>
                <!-- <td>{{ r.branch_name }}</td> -->
                <td>{{ r.expense_type_name }}</td>
                <td>{{ r.invoice_number }}</td>
                <td>{{ r.supplier_invoice_number }}</td>
                <td>{{ r.supplier_name }}</td>
                <td>{{ r.bank_name }}</td>
                <td>{{ r.amount }}</td>
                <td>{{ r.status }}</td>
                <td>{{ r.note }}</td>
                <td>{{ r.full_name }}</td>
                <td>{{ r.expense_date }}</td>
                <td>
                  <span
                    v-if="r.received_at"
                    style="display:inline-block; padding:2px 8px; border-radius:12px; font-size:12px; font-weight:500; background-color:#89D7B7; color:#1A5940;"
                  >{{ $t('finance.received') }}</span>
                </td>
                <td>{{ formatReceivedDate(r.received_at) }}</td>
                <td>
                  <a
                    v-if="$_has_perm('delete_expense')"
                    :tooltip="$t('common.delete')"
                    @click="deleteExpense(r.expense_id)"
                  >
                    <v-icon color="red darken-2">delete</v-icon>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <table class="table">
            <tr
              v-for="(f, index) in footer"
              :key="index"
            >
              <td style="padding: 3px; font-weight: bold">
                {{ f.status }}: &nbsp; {{ f.amount | usdFormat }}
              </td>
            </tr>
          </table>
          <p
            v-if="footer.length"
            class="caption grey--text text--darken-1"
            style="padding: 0 4px;"
            v-html="$t('finance.expenseFooterNote')"
          ></p>

          <add-edit
            :addEditExpenseModal="addEditExpenseModal"
            :formData="formData"
            :isUpdate="isUpdate"
            :expenseTypesList="expenseTypesList"
            :suppliersList="suppliersList"
            :banksList="banksList"
            @close="addEditExpenseModal = false"
            @resetTable="resetGetResults()"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import addEdit from './addEdit'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    addEdit
  },
  mounted() {
    this.perPageFix()
    this.getSuppliersList()
    this.getExpenseTypesList()
    this.getBanksList()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      {
        label: '',
        text: this.$t('columns.checkBox'),
        value: '1',
        sortable: false,
        searchable: false,
        name: ''
      },
      // {
      //   label: 'Branch',
      //   text: 'Branch',
      //   value: '2',
      //   sortable: true,
      //   searchable: false,
      //   name: 'branch_name'
      // },
      {
        label: this.$t('columns.expenseType'),
        text: this.$t('columns.expenseType'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'expense_type_name'
      },
      {
        label: this.$t('columns.invoiceNo'),
        text: this.$t('columns.invoiceNo'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'invoice_number'
      },
      {
        label: this.$t('columns.supplierInvoiceNo'),
        text: this.$t('columns.supplierInvoiceNo'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'supplier_invoice_number'
      },
      {
        label: this.$t('columns.supplier'),
        text: this.$t('columns.supplier'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'supplier_name'
      },
      {
        label: this.$t('columns.bank'),
        text: this.$t('columns.bank'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'bank_name'
      },
      {
        label: this.$t('columns.amount'),
        text: this.$t('columns.amount'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'amount'
      },
      {
        label: this.$t('columns.status'),
        text: this.$t('columns.status'),
        value: '7',
        sortable: true,
        searchable: true,
        name: 'status'
      },
      {
        label: this.$t('columns.note'),
        text: this.$t('columns.note'),
        value: '8',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: this.$t('columns.staff'),
        text: this.$t('columns.staff'),
        value: '9',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: this.$t('columns.expenseDate'),
        text: this.$t('columns.expenseDate'),
        value: '10',
        sortable: true,
        searchable: true,
        name: 'expense_date'
      },
      {
        label: this.$t('columns.owner'),
        text: this.$t('columns.owner'),
        value: '11',
        sortable: false,
        searchable: false,
        name: 'owner'
      },
      {
        label: this.$t('columns.receivedDate'),
        text: this.$t('columns.receivedDate'),
        value: '12',
        sortable: true,
        searchable: false,
        name: 'received_at'
      }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/expenses',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditExpenseModal: false,
      theExpenseID: '',
      prevSearchQuery: '',
      expenseTypesList: [],
      suppliersList: [],
      banksList: [],
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'expense_id',
      sortOrders: sortOrders,
      footer: [],
      selectedIds: [],
      receivedFilterItems: [
        { text: this.$t('finance.received'), value: 'received' },
        { text: this.$t('finance.notReceived'), value: 'not_received' }
      ],
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        supplier_id: '',
        branches_id: '',
        received_filter: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getSuppliersList() {
      var token = localStorage.getItem('access_token')
      axios
        .get('api/suppliers/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => {
          this.suppliersList = []
          res.data.forEach((e) => {
            this.suppliersList.push({ text: e.name, value: e.supplier_id })
          })
        })
    },

    getExpenseTypesList() {
      var token = localStorage.getItem('access_token')
      axios
        .get('api/expense_types/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => {
          this.expenseTypesList = []
          res.data.forEach((e) => {
            this.expenseTypesList.push({ text: e.name, value: e.expense_type_id })
          })
        })
    },

    getBanksList() {
      var token = localStorage.getItem('access_token')
      axios.get('api/get_banks', { headers: { Authorization: 'Bearer ' + token } }).then((res) => {
        this.banksList = []
        res.data.data.forEach((e) => {
          this.banksList.push({ text: e.bank_name, value: e.bank_id })
        })
      })
    },

    openAddExpenseModal() {
      this.formData = {}
      this.isUpdate = false
      this.addEditExpenseModal = true
    },

    openEditExpenseModal(data) {
      this.formData = data
      this.isUpdate = true
      this.addEditExpenseModal = true
    },

    deleteExpense(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(`api/expenses/${id}`, { headers: { Authorization: 'Bearer ' + token } })
            .then((response) => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false,
              })
            })
            .catch(() => { })
        }
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      // A selection made before a filter/search/reload must not silently carry over into
      // the new result set — otherwise a stale row (no longer even visible) stays selected
      // and gets included in the next bulk action (Mark Received), affecting rows the user
      // never intended to touch in the current (filtered) view.
      this.selectedIds = []

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          const data = response.data
          const payload = data.data

          let rows = []
          let foot = []

          // Paginated JSON merges `footer` with Laravel paginator keys (`data`, `total`, …).
          if (payload != null && typeof payload === 'object' && !Array.isArray(payload) && Array.isArray(payload.data)) {
            rows = payload.data
            foot = Array.isArray(payload.footer) ? payload.footer : []
            this.filterMade = false
            if (payload.total != null) {
              this.configPagination(payload)
            } else {
              this.removeConfigPagination()
            }
          } else if (Array.isArray(payload)) {
            rows = payload
            foot = []
            this.filterMade = true
            this.removeConfigPagination()
          } else {
            rows = []
            foot = []
            this.filterMade = false
            this.removeConfigPagination()
          }

          this.apiResults = rows
          this.footer = foot

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.received_filter = ''
      this.selectedIds = []
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.received_filter = ''
      this.selectedIds = []
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    checkAll() {
      this.selectedIds = this.apiResults.map(r => r.expense_id)
    },

    unCheckAll() {
      this.selectedIds = []
    },

    handleReceivedFilter(val) {
      this.tableData.received_filter = val && val.length > 0 ? val.join(',') : ''
      this.getResults()
    },

    formatReceivedDate(date) {
      if (!date) return ''
      return this.$moment(date).format('YYYY-MM-DD hh:mm a')
    },

    confirmReceiveAll() {
      if (this.selectedIds.length === 0) {
        swal({ text: this.$t('finance.pleaseSelectAtLeastOneExpense'), icon: 'warning' })
        return
      }
      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('finance.markAllSelectedExpensesReceivedConfirm'),
        icon: 'warning',
        buttons: true
      }).then(willReceive => {
        if (willReceive) {
          let token = localStorage.getItem('access_token')
          axios
            .post('api/expenses/mark-received', { expense_ids: this.selectedIds }, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then((response) => {
              this.unCheckAll()
              this.getResults()
              swal({ text: response.data.message, icon: 'success' })
            })
            .catch(() => {
              swal({ text: this.$t('finance.somethingWentWrong'), icon: 'error' })
            })
        }
      })
    },
  },
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/expense/expenses.vue